export default {
  methods: {
    showSimpleAlerte(position, icon, text) {
      this.$swal({
        position: position || 'top-end',
        icon: icon,
        text: text,
        showConfirmButton: false,
        timer: window.Timer,
      });
    },
    showConfirmDelete(msg) {
      let message = msg ? msg : 'Etes-vous sûr de continuer ?';
      return this.$swal({
        icon: 'warning',
        title: 'Suppression',
        text: message,
        showCancelButton: true,
        allowOutsideClick: false,
        reverseButtons: true,
        cancelButtonColor: '#d33',
        confirmButtonColor: '#ad932f',
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
      });
    },
    showConfirmValidation(msg = null) {
      let message = msg ? msg : 'Etes-vous sûr de continuer ?';
      return this.$swal({
        icon: 'warning',
        title: 'Confirmation',
        text: message,
        showCancelButton: true,
        allowOutsideClick: false,
        reverseButtons: true,
        cancelButtonColor: '#d33',
        confirmButtonColor: '#ad932f',
        confirmButtonText: 'Je veux continuer',
        cancelButtonText: 'Annuler',
      });
    },
  },
};
